/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelItemWithVisibilityMetadata } from '../../models/travel-item-with-visibility-metadata';

export interface TravelControllerDeleteTravel$Params {
  id: number;
}

export function travelControllerDeleteTravel(http: HttpClient, rootUrl: string, params: TravelControllerDeleteTravel$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemWithVisibilityMetadata;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerDeleteTravel.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelItemWithVisibilityMetadata;
      }>;
    })
  );
}

travelControllerDeleteTravel.PATH = '/travel/{id}';
